import { defineMessages } from 'react-intl';

export const genderOptions = defineMessages({
  MALE: {
    id: 'collegeevents.filters.genders.male',
    defaultMessage: 'Male',
  },
  FEMALE: {
    id: 'collegeevents.filters.genders.female',
    defaultMessage: 'Female',
  },
  UNSPECIFIED: {
    id: 'collegeevents.filters.genders.unspecified',
    defaultMessage: 'Unreported',
  },
});

export const distanceUnitOptions = defineMessages({
  MILES: {
    id: 'collegeevents.filters.distance-units.miles',
    defaultMessage: 'miles',
  },
  KILOMETERS: {
    id: 'collegeevents.filters.distance-units.kilometers',
    defaultMessage: 'kilometers',
  },
});

export const gradeLevelOptions = defineMessages({
  GRADE_9: {
    id: 'collegeevents.filters.grade-levels.grade9',
    defaultMessage: 'Freshman',
  },
  GRADE_10: {
    id: 'collegeevents.filters.grade-levels.grade10',
    defaultMessage: 'Sophomore',
  },
  GRADE_11: {
    id: 'collegeevents.filters.grade-levels.grade11',
    defaultMessage: 'Junior',
  },
  GRADE_12: {
    id: 'collegeevents.filters.grade-levels.grade12',
    defaultMessage: 'Senior',
  },
});

export const ethnicityOptions = defineMessages({
  AMERICAN_INDIAN: {
    id: 'collegeevents.filters.ethnicities.american-indian',
    defaultMessage: 'American Indian or Alaskan Native',
  },
  ASIAN: {
    id: 'collegeevents.filters.ethnicities.asian',
    defaultMessage: 'Asian',
  },
  BLACK: {
    id: 'collegeevents.filters.ethnicities.black',
    defaultMessage: 'Black or African American',
  },
  FILIPINO: {
    id: 'collegeevents.filters.ethnicities.filipino',
    defaultMessage: 'Filipino',
  },
  HISPANIC: {
    id: 'collegeevents.filters.ethnicities.hispanic',
    defaultMessage: 'Hispanic/Latino of any race',
  },
  MULTI_RACIAL: {
    id: 'collegeevents.filters.ethnicities.multi-racial',
    defaultMessage: 'Two or more races',
  },
  PACIFIC_ISLANDER: {
    id: 'collegeevents.filters.ethnicities.pacific-islander',
    defaultMessage: 'Native Hawaiian or Other Pacific Islander',
  },
  WHITE: {
    id: 'collegeevents.filters.ethnicities.white',
    defaultMessage: 'White',
  },
  OTHER: {
    id: 'collegeevents.filters.ethnicities.other',
    defaultMessage: 'Other',
  },
  UNKNOWN: {
    id: 'collegeevents.filters.ethnicities.unknown',
    defaultMessage: 'Race and ethnicity unknown',
  },
  UNREPORTED_BY_SCHOOL: {
    id: 'collegeevents.filters.ethnicities.unreported',
    defaultMessage: 'Unreported by school',
  },
});

export const letterGradeOptions = defineMessages({
  A: {
    id: 'collegeevents.filters.letter-grades.A',
    defaultMessage: 'A',
  },
  B: {
    id: 'collegeevents.filters.letter-grades.B',
    defaultMessage: 'B',
  },
  C: {
    id: 'collegeevents.filters.letter-grades.C',
    defaultMessage: 'C',
  },
  D: {
    id: 'collegeevents.filters.letter-grades.D',
    defaultMessage: 'D',
  },
  UNSPECIFIED: {
    id: 'collegeevents.filters.letter-grades.unspecified',
    defaultMessage: 'Unspecified',
  },
});
